import { UserProfile } from '../@posturinn/client-react';
import { IUserService } from '../@posturinn/common-react/core';
import {
	ADD_USER_EMAIL_ERROR,
	ADD_USER_EMAIL_FULFILLED,
	ADD_USER_EMAIL_PENDING,
} from '../constants/actions/userActions';
import { VERIFY_EMAIL_SECURE_MODAL } from '../constants/documentTypes/modals/modals';

import userProfile from '../components/myPost/settings/userProfile';
import { closeAllModals, setActiveModal } from './modalActions';
import { updateUserProfile } from './userProfileActions';

export const addEmail = (userId: string, email: string, newUserProfile?: UserProfile) => {
	return async function (dispatch, getState) {
		const { injector } = getState().mobizReducer;
		const userService: IUserService = injector.get(IUserService);

		dispatch(addEmailUserPending());
		userService.addEmail(userId, email).subscribe({
			next: userEmail => {
				dispatch(addEmailFulfilled(userEmail));

				dispatch(closeAllModals());
				if (!userEmail.verified && userProfile) {
					dispatch(setActiveModal(VERIFY_EMAIL_SECURE_MODAL, email));
				} else {
					dispatch(updateUserProfile(newUserProfile));
				}
			},
			error: error => {
				let err = '';
				try {
					err = error.info.details;
				} catch (e) {
					// Intentionally left blank: fallback not needed
				}
				dispatch(addEmailError(err));
			},
		});
	};
};

export const addEmailFulfilled = data => ({
	type: ADD_USER_EMAIL_FULFILLED,
	payload: {
		userEmail: data,
	},
});

export const addEmailUserPending = () => ({
	type: ADD_USER_EMAIL_PENDING,
});

export const addEmailError = error => ({
	type: ADD_USER_EMAIL_ERROR,
	payload: error,
});

